import { Kpi, KpiCalculationParams, KpiConfig, KpiConfigMeta, KPI_COMPONENTS } from '../../../../types';
import { format } from './kpi-formatter';

export class TotalValueConfig implements KpiConfig {
  private id = KPI_COMPONENTS.TOTAL_VALUE as const;
  private title = 'Total Value';
  private type = 'currency';

  getMeta(): KpiConfigMeta {
    return {
      id: this.id,
      title: this.title,
      type: this.type,
    };
  }

  calculate({ data }: KpiCalculationParams): Kpi {
    const value =
      data?.metrics?.reduce((sum, curr) => {
        return sum + (curr.totalValue ?? 0);
      }, 0) ?? 0;

    return {
      ...this.getMeta(),
      value,
      formatted: format(value, this.type),
    };
  }
}
